<div *ngIf="percent != 100" class="pnl-welcome">
  <div class="pnl-steps">
    <div>
      <b>
        <span class="lbl">{{ percent }}%</span>
        <span
          class="wrapper"
          [class.p25]="percent == 25"
          [class.p50]="percent >= 50"
        ></span>
        <span class="wrapper" [class.p75]="percent == 75"></span>
      </b>
      <div>
        <strong>Bem-vindo! Conclua os passos para lançar a loja</strong>
        <span>{{ steps_remaining }} passos pendentes</span>
      </div>
    </div>
    <ul>
      <li class="done"><b></b><span>Conta criada na Segcommerce</span></li>
      <li [class.selected]="percent == 50" [class.done]="percent > 50">
        <b>{{ percent > 50 ? "" : "2" }}</b
        ><span>Atualizar preço dos produtos</span
        ><small *ngIf="!(percent > 50)">Pendente</small>
      </li>
      <!-- <li [class.selected]="percent == 50" [class.done]="percent > 50">
        <b>{{ percent > 50 ? "" : "3" }}</b
        ><span>Criar um endereço virtual</span
        ><small *ngIf="!(percent > 50)">Pendente</small>
      </li> -->
      <li [class.selected]="percent == 75">
        <b>3</b><span>Inserir uma logomarca</span><small>Pendente</small>
      </li>
    </ul>
  </div>
  <div class="pnl-content">
    <div [class.dnone]="percent != 50">
      <h2>Atualizar preço dos produtos</h2>
      <p>
        Escolha uma das maneiras de atualizar os preços de todos os produtos de
        uma só vez no seu e-commerce.
      </p>
      <strong>Atualização manual</strong>
      <div>
        <p>
          Importe o arquivo com a tabela de preços dos produtos do seu
          supermercado. A plataforma irá fazer a leitura dos dados e atualizará
          os preços no e-commerce.
          <a (click)="onOpenModalImportEx()">ver exemplo</a>
        </p>

        <input
          id="fileUploader"
          #fileUploader
          type="file"
          ng2FileSelect
          [uploader]="uploader"
          class="dnone"
        />

        <button (click)="fileUploader.click()">
          <fa-icon [icon]="faCloudUploadAlt"></fa-icon> importar arquivo
        </button>
      </div>
      <strong>Atualização automática</strong>
      <div>
        <p>
          Se você já possui um sistema de ERP dentro do seu supermercado,
          recomendamos fazer a integração para manter os preços sincronizados em
          ambos sistemas.
        </p>
        <a (click)="aboutERP()" class="arrow"
          >Ok, entendi. Quero saber mais sobre a integração</a
        >
      </div>
    </div>

    <!-- <div [class.dnone]="percent != 50">
      <h2>Criar um endereço virtual</h2>
      <p>
        Torne mais fácil para os seus clientes encontrarem na internet o seu
        e-commerce. Mais tarde, quando estiver pronto, você poderá optar por
        usar seu próprio domínio personalizado.
      </p>
      <div>
        <div class="ipt-dominio">
          <input
            [(ngModel)]="store_name"
            maxlength="30"
            (keyup)="onFormatSub()"
            [class.error]="error_name"
          />
          <span>.superhoje.com</span>
        </div>
        <a (click)="confirmSubdomain()">Confirma essa escolha?</a>
      </div>
    </div> -->

    <div [class.dnone]="percent != 75">
      <h2>Inserir uma logomarca</h2>
      <p>Deixe o seu e-commerce com a identidade visual da sua loja física.</p>
      <div>
        <div
          class="drop-logo"
          ng2FileDrop
          [uploader]="uploaderLogo"
          (fileOver)="fileOverLogoBase($event)"
          [ngClass]="{ 'nv-file-over': hasBaseDropLogoZoneOver }"
        >
          <div
            *ngIf="
              (uploaderLogo.queue && uploaderLogo.queue.length > 0) ||
              imageLogo != ''
            "
            class="image-cover"
          >
            <img [src]="imageLogo" *ngIf="imageLogo != ''" />
            <img
              *ngFor="let item of uploaderLogo.queue; let i = index"
              src=""
              imgPreview
              [image]="item?._file"
            />
          </div>

          <div
            *ngIf="
              uploaderLogo.queue &&
              uploaderLogo.queue.length == 0 &&
              imageLogo == ''
            "
            class="image-cover"
          >
            <fa-icon [icon]="faImage"></fa-icon>

            <h6>Adicione o logo do estabelecimento</h6>
          </div>

          <input
            id="fileUploaderLogo"
            #fileUploaderLogo
            type="file"
            ng2FileSelect
            [uploader]="uploaderLogo"
            class="dnone"
          />

          <button
            *ngIf="
              (uploaderLogo.queue && uploaderLogo.queue.length > 0) ||
              imageLogo != ''
            "
            (click)="fileUploaderLogo.click()"
          >
            <span class="cicle"><fa-icon [icon]="faSyncAlt"></fa-icon></span>
            Alterar logomarca
          </button>
          <button
            *ngIf="
              uploaderLogo.queue &&
              uploaderLogo.queue.length == 0 &&
              imageLogo == ''
            "
            (click)="fileUploaderLogo.click()"
          >
            <fa-icon [icon]="faFileImage" class="ml10"></fa-icon>
            Procurar logomarca
          </button>
        </div>
      </div>
      <span
        *ngIf="
          (uploaderLogo.queue && uploaderLogo.queue.length > 0) ||
          imageLogo != ''
        "
        class="action"
      >
        <button (click)="confirmLogo()">
          <fa-icon [icon]="faCloudUploadAlt"></fa-icon>
          Confirmar e enviar a logomarca
        </button>
      </span>
    </div>
  </div>
</div>

<div *ngIf="percent == 100" class="pnl-welcome-plans">
  <div *ngIf="warning_complete" class="top">
    <span class="cicle">100%</span>
    <span
      ><strong>Muito bem! Todos os passos foram concluídos.</strong> Agora,
      deixe com os nossos especialistas. Enquanto isso, comece a explorar</span
    >
  </div>

  <h1>Conheça os planos de assinatura</h1>

  <div class="price-grid">
    <div class="dflex f1 fcolumn">
      <h3>Mini</h3>
      <strong>R$ 99<span>/mês</span></strong>
      <small>+ 2% sobre as vendas</small>
      <a (click)="openModal('Mini')" class="fill">Assinar</a>
      <p>
        Ideal para mercadinhos com até 3.000 SKU’s em estoque e que querem
        começar a vender online sem muito investimento
      </p>
      <hr />
      <b>Suporte Nível 1</b>
      <ul class="ul-first">
        <li>Suporte por email e WhatsApp</li>
      </ul>
      <hr />
      <b>Integração Nível 1</b>
      <ul>
        <li>
          A atualização dos preços ocorrerá via importação de arquivo. Não
          haverá nenhuma integração com ERP
        </li>
      </ul>
      <hr />
      <b>Limite de produtos (SKU)</b>
      <ul>
        <li>Até 3.000 produtos</li>
      </ul>
      <hr />
      <b>Aplicativo próprio</b>
      <ul>
        <li>Opcional por + R$ 299/mês</li>
      </ul>
      <hr />
      <b>Funcionalidades</b>
      <ul class="ul-last">
        <li>Relatórios básicos</li>
        <li>Aplicativo de separação</li>
      </ul>
    </div>
    <div class="dflex f1 fcolumn">
      <h3>Super</h3>
      <strong>R$ 299<span>/mês</span></strong>
      <small>+ 1% sobre as vendas</small>
      <a (click)="openModal('Super')" class="fill">Assinar</a>
      <p>
        Ideal para supermercados com +100.000 SKU’s e que já têm alguma
        experiência com vendas via WhatsApp e querem profissionalizar o negócio
      </p>
      <hr />
      <b>Suporte Nível 2</b>
      <ul class="ul-first">
        <li>Suporte por email e WhatsApp</li>
        <li>Especialista em implantação</li>
      </ul>
      <hr />
      <b>Integração Nível 2</b>
      <ul>
        <li>
          As atualizações dos preços e do estoque serão automatizadas com
          integração via ERP para manter tudo sincronizado
        </li>
      </ul>
      <hr />
      <b>Limite de produtos (SKU)</b>
      <ul>
        <li>Ilimitado</li>
      </ul>
      <hr />
      <b>Aplicativo próprio</b>
      <ul>
        <li>Opcional por + R$ 199/mês</li>
      </ul>
      <hr />
      <b>Funcionalidades</b>
      <ul class="ul-last">
        <li>Relatórios básicos</li>
        <li>Aplicativo de separação</li>
        <li>Ferramentas de marketing</li>
        <li>Notificação do pedido via SMS</li>
      </ul>
    </div>
    <div class="dflex f1 fcolumn">
      <h3>Filiais</h3>
      <strong>Cotar</strong>
      <small></small>
      <a
        href="https://segcommerce.com.br/atendimento"
        target="_blank"
        class="outline"
        >Fale com um vendedor</a
      >
      <p>
        Ideal para supermercados com várias lojas e querem implantar uma
        experiência completamente omnichannel
      </p>
      <hr />
      <b>Suporte Nível 3</b>
      <ul class="ul-first">
        <li>Suporte por email e WhatsApp</li>
        <li>Especialista em implantação</li>
        <li>Consultor dedicado</li>
      </ul>
      <hr />
      <b>Integração Nível 3</b>
      <ul>
        <li>
          Além da integração Nível 2, haverá integração com PDV e com sistemas
          de atendimento e marketing
        </li>
      </ul>
      <hr />
      <b>Limite de produtos (SKU)</b>
      <ul>
        <li>Ilimitado</li>
      </ul>
      <hr />
      <b>Aplicativo próprio</b>
      <ul>
        <li>Incluído no pacote</li>
      </ul>
      <hr />
      <b>Funcionalidades</b>
      <ul class="ul-last">
        <li>Relatórios básicos</li>
        <li>Aplicativo de separação</li>
        <li>Ferramentas de marketing</li>
        <li>Notificação do pedido via SMS</li>
        <li>Análises perfil de consumo</li>
      </ul>
    </div>
  </div>
</div>

<div *ngIf="modalOpen" class="pnl-welcome-modal">
  <div>
    <div class="astart prelative">
      <a (click)="closeModal()">Planos de assinatura</a>
      <h2>Assinar com boleto bancário</h2>
      <form
        class="dflex f1 fcolumn w100"
        [formGroup]="subFrm"
        (ngSubmit)="onSubmitSubcribe()"
        novalidate
      >
        <div class="dflex frow mb20">
          <div class="dflex fcolumn f2 mr10">
            <label>Nome empresarial (Razão Social)</label>
            <input
              formControlName="razao_social"
              [class.error]="!razao_social.valid && razao_social.dirty"
            />
          </div>
          <div class="dflex fcolumn f1 ml10">
            <label>CNPJ</label>
            <input
              mask="00.000.000/0000-00"
              formControlName="cnpj"
              placeholder="00.000.000/0000-00"
              [class.error]="!cnpj.valid && cnpj.dirty"
            />
          </div>
        </div>
        <div class="dflex mt10 frow">
          <div class="dflex fcolumn f2 mr10">
            <label>E-mail que receberá o boleto</label>
            <input
              formControlName="email"
              [class.error]="!email.valid && email.dirty"
            />
          </div>
          <div class="dflex fcolumn f1 ml10">
            <label>CEP</label>
            <input
              (keyup)="onCEPChange()"
              mask="00000-000"
              formControlName="cep"
              placeholder="00000-000"
              [class.error]="invalid_cep || (!cep.valid && cep.dirty)"
            />
          </div>
        </div>
        <div *ngIf="store_address" class="dflex mt20 fcolumn">
          <span class="mb10"
            >Baseado no CEP informado, o seu endereço fiscal é:</span
          >
          <strong class="mt10">{{ store_address }}</strong>
        </div>
        <div class="dflex frow f1 jstart aend mb20 btn-action">
          <div class="dflex frow acenter mb20">
            <button type="submit" [class.disabled]="!subFrm.valid">
              Concluir assinatura
            </button>
            <p class="label">
              O plano é Pós-pago. <br />
              Você será faturado após 30 dias.
            </p>
          </div>
        </div>
      </form>

      <div class="loading" *ngIf="loadingCEP">
        <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
          <div class="ldio-ns36390yc">
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="dflex fcolumn resume">
      <span class="label">Plano escolhido</span>
      <div class="dflex w100 frow acenter">
        <div class="logo">
          <img src="assets/img/logo-segcommerce-white-small.png" />
        </div>
        <strong class="f1">Segcommerce {{ plan }}</strong>
        <b class="dflex fcolumn jend rtext value">
          <span>R$ {{ plan_value }}</span>
          <small>por mês</small>
        </b>
      </div>
      <hr />
      <span class="label">Contratar opcionais?</span>
      <div class="dflex w100 frow acenter">
        <div class="ipt-checkbox">
          <input
            id="extra_opc"
            type="checkbox"
            (change)="sumPlan()"
            [(ngModel)]="app_owner"
          />
          <label for="extra_opc"></label>
        </div>
        <strong class="f1"
          ><label class="cpointer" for="extra_opc"
            >Aplicativo próprio</label
          ></strong
        >
        <b class="dflex fcolumn jend rtext value">
          <span>R$ 299</span>
          <small>por mês</small>
        </b>
      </div>
      <hr />
      <div class="total dflex w100 frow astart">
        <strong class="f1">Total a pagar</strong>
        <b class="dflex fcolumn jend rtext">
          <span>R$ {{ total }}</span>
          <small>por mês</small>
          <small>+2% sobre as vendas</small>
        </b>
      </div>
    </div>
  </div>
</div>

<div class="loading" *ngIf="loading">
  <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
    <div class="ldio-ns36390yc">
      <div></div>
    </div>
  </div>
</div>

<div class="modal" [class.dnone]="!modalImportEx" [class.open]="modalImportEx">
  <div class="modal-content modal-exemplo">
    <div class="exemplo">
      <strong
        >Exemplo da tabela:
        <small>campos obrigatórios: ean, descrição e preço</small></strong
      >
      <figure>
        <img src="assets/img/exemplo_excel.png" />
      </figure>
    </div>

    <div class="dflex frow mt20 mb20 jend">
      <button
        type="button"
        (click)="onCloseModalImportEx()"
        class="btn btn-cancel mr10"
      >
        Fechar
      </button>
    </div>
  </div>
</div>
